import axios from 'axios';
import cookies from 'js-cookie';

/*
This instance should be imported wherever you need to make HTTP requests across the project.
*/
const axiosInstance = axios.create({
  headers: {
    post: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    common: {
      'X-Xsrf-Token': cookies.get('csrf_cookie_name'),
      'X-Requested-With': 'XMLHttpRequest'
    }
  }
});

export default axiosInstance;
